class AccessKeyConsts {
  public static readonly NameMaxLength: number = 255;
}

export default AccessKeyConsts;